import { memo, useMemo, useState } from "react";
import { Button, Tab, Tabs } from "react-bootstrap";
import { convertToMomentDate, successMessageToast, userFullName } from "helpers/common";
import styles from "../ClientDetail.module.scss";
import { cloneDeep } from "lodash";
import EvaluationPop from "components/Modals/EvaluatePop";
import confirmDialog from "utils/confirmationDialog";
import { useShareEvaluationMutation } from "store/services/clients/apprentice";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ChatterSendMailPop from "components/Modals/ChatterSendMailPop";


const Attendance = ({ data, handleAttendance, refetch }) => {
  const [tableRow, setTableRow] = useState(false);

  const [currentEntry, setCurrentEntry] = useState(null);
  const [activeSessionTab, setActiveSessionTab] = useState("peer");
  const [showEvaluateModal, setShowEvaluateModal] = useState(false);
  const [currentTabDate, setCurrentTabDate] = useState();
  
  const [shareEvaluation, { isLoading: shareEvaluationLoading }] = useShareEvaluationMutation();

  const handleTabSelect = (key) => {
    setActiveSessionTab(key);
  };

  const sendEvaluationReport = async (programId, peerId, therapistHead, sessionDate) => {
    try {
      let isConfirm = await confirmDialog();
      if (!isConfirm) return;

      const payload = {
        programId,
        peerId,
        therapistHead,
        sessionDate
      }

      let result = await shareEvaluation(payload);
      successMessageToast(result?.data?.message || "Evaluation report sent successfully");
    } catch (err) {
      console.error("Error sharing evaluation", err);
    }
  }

  const sortedMembers = useMemo(() => {
    const membersClone = cloneDeep(data?.programMembers);
    membersClone.sort((a, b) => {
      const firstA = a.programMember.firstname.toLowerCase();
      const firstB = b.programMember.firstname.toLowerCase();
      const lastA = a.programMember.lastname.toLowerCase();
      const lastB = b.programMember.lastname.toLowerCase();

      if (firstA !== firstB) {
        return firstA.localeCompare(firstB); // Sort by firstname first
      }
      return lastA.localeCompare(lastB); // If firstname is the same, sort by lastname
    });

    return membersClone;
  }, [data]);

  return (
    <>
      <EvaluationPop
        confirmation={showEvaluateModal}
        setConfirmation={setShowEvaluateModal}
        type={"delete"}
        client={currentEntry}
        programId={data.id}
        tabDate={currentTabDate}
        refetch={refetch}
      />
      {shareEvaluationLoading && <LoadingOverlay />}
      <table className={`${styles.table} table mb-0`}>
        {
          data?.lessonDates?.map((item, index) => {
            return <tbody>
              <tr onClick={() => setTableRow(tableRow == index ? null : index)}>
                <td className="">{convertToMomentDate(item?.session_date)}</td>

                <td className="">
                  <Button
                    className="border-0 p-0"
                    variant="transparent"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M10 7.26925L6.4615 10.8078L13.5385 10.8078L10 7.26925ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
                        fill="#071E3E"
                      />
                    </svg>
                  </Button>
                </td>
              </tr>
              {tableRow == index ? (
                <tr>
                  <td colSpan={4} className="p-0 border-0">
                    <div
                      className={`${styles.tableResponsive} tableResponsive table-responsive mb-0 pb-0`}
                    >
                      <Tabs
                        // defaultActiveKey={"chatter"}
                        defaultActiveKey={activeSessionTab}
                        className="my-1"
                        onSelect={handleTabSelect}
                      >
                        <Tab eventKey="chatter" title="Chatter Client" className="themeClr">
                          <RenderMembersAttendance
                            data={data}
                            memberType={"chatter"}
                            programMembers={sortedMembers}
                            item={item}
                            handleAttendance={handleAttendance}
                          />
                        </Tab>
                        <Tab eventKey="peer" title="Peer Mentor">
                          <RenderMembersAttendance
                            memberType={"peer"}
                            programMembers={sortedMembers}
                            item={item}
                            handleAttendance={handleAttendance}
                            setCurrentEntry={setCurrentEntry}
                            setShowEvaluateModal={setShowEvaluateModal}
                            setCurrentTabDate={setCurrentTabDate}
                            programId={data.id}
                            sendEvaluationReport={sendEvaluationReport}
                          />
                        </Tab>
                      </Tabs>
                    </div>
                  </td>
                </tr>
              ) : null}
            </tbody>
          })
        }
      </table>
    </>
  )
}

const RenderMembersAttendance = memo(({ memberType, programMembers, item, handleAttendance, setCurrentEntry, setShowEvaluateModal, programId, setCurrentTabDate, sendEvaluationReport, data }) => {
  const [attendanceEntry, setAttendanceEntry] = useState(null)
  const [chatterMailModal, setChatterMailModal] = useState(false)
  const membersList = useMemo(() => {
    if (!programMembers?.length || !memberType) {
      return [];
    }

    return programMembers?.filter(member => member?.programMember?.client_detail?.client_type === memberType);
  }, [programMembers, memberType]);

  return (
    <>
      <ChatterSendMailPop attendanceEntry={attendanceEntry}  show={chatterMailModal} setShow={setChatterMailModal} />
      <div className="">
        <table className="table">
          <thead className="border">
            <tr className="">
              <th className="text-dark fw-bold bg-transparent">
                USERS
              </th>
              <th className="text-dark fw-bold bg-transparent">
                PRESENT
              </th>
              {memberType === 'peer' ? (
                <th className="text-dark fw-bold bg-transparent">
                  EVALUATE
                </th>
              ) : data?.location_type == "community" && (
                <th className="text-dark fw-bold bg-transparent">
                  PARENT
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {membersList?.length > 0 ? (
              membersList?.map((member, ind) => {
                if (member?.programMember?.client_detail?.client_type !== memberType) {
                  return null;
                }
                const userAttendance = item?.attendance?.find(x => x.member_id == member.id);
                const evaluationData = member?.programMember.evaluatedPeer.find(x => x.session_date === item?.session_date);
                const submitted = member?.programMember.evaluatedPeer.some(x => x.session_date === item?.session_date);
                return (
                  <tr key={ind}>
                    <td className="border-0 p-2 text-capitalize">
                      {userFullName(member?.programMember)}
                    </td>
                    <td className="border-0 p-2">
                      <span onClick={() => {
                        handleAttendance(member.id, {
                          session_date: item?.session_date,
                          attendance: userAttendance?.attendance == "present" ? "absent" : "present",
                          with_parent: userAttendance?.with_parent ?? "no"
                        })
                      }} >
                        {userAttendance?.attendance == "present" ? <PresentIcon /> : <AbsentIcon />}
                      </span>
                    </td>
                    {memberType === 'peer' ? (
                      <td className="border-0 p-2">
                        <div className="d-flex gap-1">
                          <Button
                            style={{ padding: "0", height: "30px", minWidth: "70px" }}
                            className={`px-2 d-flex align-items-center justify-content-center commonBtn 
                                ${submitted ? "commonSuccessBtn" : "commonBtn"}`}
                            onClick={() => {
                              setShowEvaluateModal(true);
                              setCurrentEntry(member);
                              setCurrentTabDate(item?.session_date);
                            }}
                          >
                            {submitted ? "Submitted" : "Start"}
                          </Button>
                          {submitted && (
                            <Button
                              style={{ padding: "0", height: "30px", minWidth: "70px" }}
                              className={`p-0 d-flex align-items-center justify-content-center commonBtn`}
                              onClick={() => {
                                setAttendanceEntry({ programId, peerId: evaluationData.peer_id, evaluationBy: evaluationData?.evaluationBy, sessionDate: item?.session_date, programMember: member?.programMember });
                                setChatterMailModal(true)
                                // setChatterMailModal(true); sendEvaluationReport(programId, evaluationData.peer_id, evaluationData?.evaluationBy, item?.session_date)
                              }}
                            >
                              Send
                            </Button>
                          )}
                        </div>
                      </td>
                    ) : data?.location_type == "community" && (
                      <td className="border-0 p-2">
                        <span onClick={() => {
                          handleAttendance(member.id, {
                            session_date: item?.session_date,
                            attendance: userAttendance?.attendance ?? "absent",
                            with_parent: userAttendance?.with_parent == "yes" ? "no" : "yes"
                          })
                        }} >
                          {userAttendance?.with_parent == "yes" ? <PresentIcon /> : <AbsentIcon />}
                        </span>
                      </td>
                    )}
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={3} className="border-0 text-center">Data not found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  )
})

const PresentIcon = () => {

  return (<svg
    style={{ cursor: "pointer" }}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
      fill="#16BF12"
    />
  </svg>)
}

const AbsentIcon = () => {

  return (
    <svg
      style={{ cursor: "pointer" }}
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
      </g>
    </svg>
  )
}

export default Attendance;